export default __webpack_public_path__ + "static/media/man_walking_in_the_snow.be370593.jpg";